<template>
    <div id="shopManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px">
                <el-input clearable v-model="searchForm.shop" placeholder="请输入门店名称"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
          <el-form-item class="fr">
            <el-col style="text-align:right">
              <el-button
                size="medium"
                type="success"
                @click="createShop()"
                v-if="basicsAuth.shopAdd"
                >新建门店</el-button
              >
              <el-button
                @click="handleImptmpl"
                type="text"
                class="el-button filter-item el-button--warning el-button--mini"
              >
                <i class="fa fa-download"></i>
                <span>下载模板</span>
              </el-button>
              <el-button
                class="el-button filter-item el-button--info el-button--mini"
                style="padding:0 0 0 0px"
              >
                <el-upload
                  ref="upload"
                  action="http-request"
                  :http-request="handleUploadFile"
                  :on-exceed="handleUploadExceed"
                  :limit="1"
                  :show-file-list="false"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                >
                  <button
                    class="el-button filter-item el-button--info el-button--mini"
                  >
                    <i class="fa fa-upload"></i>
                    <span>导入</span>
                  </button>
                </el-upload>
              </el-button>
              <el-button
                @click="handleExport"
                type="button"
                class="el-button filter-item el-button--warning el-button--mini"
              >
                <i class="fa fa-download"></i>
                <span>导出</span>
              </el-button>
              <i
                class="el-icon-refresh"
                style="font-size: 25px;cursor: pointer;margin-left: 30px;"
                @click="refresh()"
              ></i>
            </el-col>
          </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="attribute4"
                    label="M4门店ID">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="name"
                    label="门店">
                </el-table-column>
                <!-- <el-table-column
                    align="center"
                    prop="attribute1"
                    label="机构">
                </el-table-column> -->
                <el-table-column
                    align="center"
                    prop="site"
                    label="门店地址">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="启用状态">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.status == '1'">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="极吼吼显示">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.isShowWx == '1'">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="全服到家显示">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.isShowGpp == '1'">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    :key="Math.random()"
                    v-if="basicsAuth.shopEdit">
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="600px" @close="emptyDialog('storeForm')">
                <el-form ref="storeForm" :model="storeForm" label-width="100px" :label-position="labelPosition">
                  <el-form-item label="M4门店ID">
                        <el-input v-model.trim="storeForm.attribute4" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="门店名称" prop="storeName">
                        <el-input v-model.trim="storeForm.storeName"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="选择机构" prop="organize">
                        <el-cascader
                            style="width:100%;"
                            :options="options"
                            v-model="storeForm.organize"
                        ></el-cascader>
                    </el-form-item> -->
                    <el-form-item label="门店地址" prop="storeAddress">
                        <el-input v-model.trim="storeForm.storeAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input v-model.trim="storeForm.contacts" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话">
                        <el-input v-model.trim="storeForm.contactsPhone" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="营业时间">
                        <el-input v-model.trim="storeForm.attribute3" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态" prop="delivery">
                        <el-switch @change="getStatus" v-model="storeForm.delivery" :active-value="1"
                        :inactive-value="-1" ></el-switch>
                    </el-form-item>
                    <el-form-item label="极吼吼显示">
                        <el-switch @change="getWxStatus" v-model="storeForm.isShowWx" :active-value="1"
                        :inactive-value="-1" ></el-switch>
                    </el-form-item>
                    <el-form-item label="全服到家显示">
                        <el-switch @change="getGppStatus" v-model="storeForm.isShowGpp" :active-value="1"
                        :inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="dialogMenuStatus=='create'" type="primary" @click="createData()" >立即创建</el-button>
                    <el-button v-else type="primary" @click="updateData()">保存</el-button>
                    <el-button @click="emptyDialog('storeForm')">取消</el-button>
                </div>
            </el-dialog>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>
    </div>
</template>

<script>
import { hideLoading, showLoading } from "../../components/loading/loading";
import {
    shopList,
    shopAdd,
    shopEdit,
    getDeptlist,
    shopExport,
    shopImport,
    shopImptmpl
} from "../../api/api";
  import {getPermission} from '../../api/authRequest';

export default {
    name: 'shopManage',
    inject:['reload'],
    components: {
    },
    data () {
        return {
          //分页变量
            pages:{
                total: 0,
                page: 1,
                pageSize: 10,
            },
            labelPosition:'left',
            dialogMenuStatus: "",
            textMenu: {
                update: "修改门店",
                create: "新增门店"
            },
            options: [],
            dislogCreate:false,
            labelPosition:'left',
            storeForm:{
                id:'',
                storeName: '',
                organize: [],
                storeAddress: '',
                delivery: "1",
                isShowWx: "0",
                isShowGpp: "0",
                attribute4: '',
                attribute3: '',
                contacts: '',
                contactsPhone:'',
            },
            searchForm:{
                shop: '',
            },
            returnData: [],
            testData:[],
            basicsAuth:{
                shopDetail:false,
                shopAdd:false,
                shopList:false,
                shopEdit:false
            }
        }
    },
    created(){
        this.getShopList()
        this.getDeptlistData()
    },
     mounted () {
        this.basicsAuth.shopDetail= getPermission('/api/shop/shopDetails');
        this.basicsAuth.shopAdd= getPermission('/api/shop/shopAdd');
        this.basicsAuth.shopList= getPermission('/api/shop/shopList');
        this.basicsAuth.shopEdit= getPermission('/api/shop/shopEdit');
     },
    methods: {
        clearFrom(){
            this.searchForm.shop = "";
        },
        //清空dialog
        emptyDialog(formName) {
            this.$refs[formName].resetFields();
            this.storeForm = {
                id:'',
                storeName: '',
                organize: [],
                storeAddress: '',
                delivery: 1,
                isShowWx: 0,
                isShowGpp: 0,
                attribute4: '',
                attribute3: '',
                contacts: '',
                contactsPhone:'',
            };
            this.dislogCreate = false;
        },
        //获取门店列表
        getShopList(){
            let para={
                startRow:this.pages.page,
                pageSize:this.pages.pageSize,
                name:this.searchForm.shop
            }
            shopList(para).then(res => {
                if (res.data.status==100) {
                    this.returnData = res.data.results.list
                    this.pages.total = res.data.results.total
                }else{
                    this.$message({
                        message: res.data.message,
                        type: "error"
                    });
                }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //获取组织机构列表
        getDeptlistData(){
            let para={};
            getDeptlist(para).then(res => {
                if (res.data.status==100) {
                    let storeArr = res.data.results.Deptlist;
                    storeArr.forEach((item,index) =>{
                        let obj = {}
                        let children = []
                        obj.value = item.deptId
                        obj.label = item.deptName
                        item.children.forEach((item1,index1)=>{
                            let obj1 = {}
                            // let children1 = []
                            let children2 = []
                            obj1.value = item1.deptId
                            obj1.label = item1.deptName
                            item1.children.forEach((item2,index2)=>{
                                let obj2 = {}
                                obj2.value = item2.deptId
                                obj2.label = item2.deptName
                                // obj2.children = children1
                                children2.push(obj2)

                            })
                            obj1.children = children2
                            children.push(obj1)
                        })
                        obj.children = children
                        this.options.push(obj)
                        // console.log(JSON.stringify(this.options))
                    })
                }else{
                    this.$message({
                        message: res.data.message,
                        type: "error"
                    });
                }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
        },
        //新建门店
        createShop() {
            this.dislogCreate = true
            this.dialogMenuStatus = "create";
        },
        //确认新建
        createData(){
            if(this.storeForm.storeName == ''){
                this.$message({
                    message: '请输入门店名称',
                    type: "error"
                });
            }
            // else if (this.storeForm.organize == '') {
            //     this.$message({
            //         message: '请选择机构',
            //         type: "error"
            //     });
            // }
            else if (this.storeForm.storeAddress == '') {
                this.$message({
                    message: '请输入门店地址',
                    type: "error"
                });
            }else{
                this.dislogCreate = false
                let para = {
                    name:this.storeForm.storeName,
                    deptId:this.storeForm.organize[2],
                    site:this.storeForm.storeAddress,
                    status:this.storeForm.delivery,
                    isShowWx:this.storeForm.isShowWx,
                    isShowGpp: this.storeForm.isShowGpp,
                    attribute4: this.storeForm.attribute4,
                    attribute3: this.storeForm.attribute3,
                    contacts: this.storeForm.contacts,
                    contactsPhone: this.storeForm.contactsPhone,
                };
                shopAdd(para).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: '创建成功！',
                            type: "success"
                        });
                        //刷新
                        this.getShopList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                  this.$Message.error(error.message);
                })
            }
        },
        //修改门店
        exitBtn(index,item) {
            this.dislogCreate = true
            this.dialogMenuStatus = "update";
            let selectObj = Object.assign({}, item);
            console.log(Object.assign({}, item))
            this.storeForm.storeName = selectObj.name;
            this.storeForm.storeAddress = selectObj.site;
            this.storeForm.delivery = Number(selectObj.status);
            this.storeForm.isShowWx = Number(selectObj.isShowWx);
            this.storeForm.isShowGpp = Number(selectObj.isShowGpp);
            this.storeForm.attribute4 = selectObj.attribute4;

            this.storeForm.attribute3 = selectObj.attribute3;
            this.storeForm.contacts = selectObj.contacts;
            this.storeForm.contactsPhone = selectObj.contactsPhone;

            this.storeForm.id = selectObj.id

        },
        handleSizeChange(val) {
            this.pages.pageSize = val
            this.getShopList()
        },
        handleCurrentChange(Page) {
            this.pages.page = Page
            this.getShopList()
        },
        //启用/禁用
        getStatus(val){
            this.storeForm.delivery = (val == -1) ? 0 : 1;
        },
        getWxStatus(val){
            this.storeForm.isShowWx = (val == -1) ? 0 : 1;
        },
        getGppStatus(val){
            this.storeForm.isShowGpp = (val == -1) ? 0 : 1;
        },
        //确认修改
        updateData(){
            if(this.storeForm.storeName == ''){
                this.$message({
                    message: '请输入门店名称',
                    type: "error"
                });
            }
            // else if (this.storeForm.organize == '') {
            //     this.$message({
            //         message: '请选择机构',
            //         type: "error"
            //     });
            // }
            else if (this.storeForm.storeAddress == '') {
                this.$message({
                    message: '请输入门店地址',
                    type: "error"
                });
            }else{
                this.dislogCreate = false
                let para = {
                    name:this.storeForm.storeName,
                    deptId:this.storeForm.organize[2],
                    site:this.storeForm.storeAddress,
                    status:this.storeForm.delivery,
                    isShowWx:this.storeForm.isShowWx,
                    isShowGpp: this.storeForm.isShowGpp,
                    attribute4: this.storeForm.attribute4,
                    attribute3: this.storeForm.attribute3,
                    contacts: this.storeForm.contacts,
                    contactsPhone: this.storeForm.contactsPhone,

                    id:this.storeForm.id
                };
                shopEdit(para).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: '修改成功！',
                            type: "success"
                        });
                        //刷新
                        this.getShopList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }
        },
        //刷新
        refresh() {
            this.getShopList()
        },
        //检索提交
        onSubmit() {
            this.getShopList()
        },
        //导出
        handleExport() {
          shopExport(Object.assign({}, {name: this.searchForm.shop})).then(res => {
            this._download(res);
          });
        },
        //下载模板
        handleImptmpl() {
          shopImptmpl({}).then(res => {
            this._download(res);
          });
        },
        _download(res) {
          let fileName = res.headers["content-disposition"]
            .split(";")[1]
            .trim()
            .split("filename=")[1]
            .split('"')[1];
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            downloadElement.download = fileName;
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          }
        },
        /**
          超出最大上传文件数量时的处理方法
        */
        handleUploadExceed() {
          this.$message({
            type: "warning",
            message: "超出最大上传文件数量的限制！"
          });
          return;
        },
        /**
         * 自定义上传
         */
        handleUploadFile(params) {
          let _self = this;

          let data = new FormData();
          data.append("file", params.file);
          showLoading();
          shopImport(data)
            .then(res => {
              if (res.data.status == 100) {
                _self.$message({
                  message: res.data.message,
                  type: "success"
                });
                //_self.onLoad();
              } else {
                _self.$message({
                  message: res.data.message,
                  type: "warning"
                });
              }
            })
            .finally(() => {
              hideLoading();
            });
          _self.$refs.upload.clearFiles();
        }
    },
    computed: {
    },
    watch: {

    }
}
</script>

<style lang="scss" type="text/css" scoped>
  #shopManage{font-size: 14px;
    .headerT{margin:8px 0 15px 0;width: 80px;}

  }
  #section {-webkit-box-shadow: 0px 0px 4px rgba(0,0,0,.2);box-shadow: 0px 0px 4px rgba(0,0,0,.2);padding: 15px 20px;margin-bottom: 15px;}
    #choose {margin: 0 auto;line-height: 24px;}
    #type {width: 100%;padding: 10px 0 16px 0px;}
    #type li {color: #8a8a8a;line-height: 34px;}
    #type a {margin: 0 12px 0 10px;color: #000;border:1px solid transparent;}
    #choose mark {
      position: relative;
      display: inline-block;
      height: 24px;
      line-height: 24px;
      border: 1px solid #28a5c4;
      color: #28a5c4;
      margin: -1px 5px 5px 0;
      background: none;
      padding: 0 30px 0 6px;
      text-indent: 0;
      /*top: 5px;*/
    }
    #choose mark a {
      position: absolute;
      /*top: -5px;*/
      right: 0px;
      display: inline-block;
      width: 18px;
      height: 22px;
      background: #28a5c4;
      color: #fff;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
      }
      #type a.active {/*border:1px solid #1abc9c;*/color:#28a5c4;}

</style>



// WEBPACK FOOTER //
// shopManage.vue?6ffdd4f0